<template>
  <v-app>
    <v-main>
      <component v-bind:is="componente"></component>
    </v-main>
  </v-app>
</template>

<style>
  @import 'material_icons/material-icons.css';
</style>

<script>
import Login from './components/Login';
export default {
  name: 'App',
  components: { Login },
  data: () => ({
    componente:'Login',
  }),
};
</script>
